<ng-container *ngIf="this.mode === 'edit'">
  <div class="row">
    <div class="col-4">
      <input
        #search
        [(ngModel)]="searchString"
        (keyup)="filterChange()"
        class="form-control"
        i18n-placeholder="@@search-ellipsis"
        placeholder="Suche..."
      >
    </div>
    <div class="col"></div>
    <div class="col-auto">
      <div class="btn-group">
        <div
          class="btn btn-outline-primary"
          (click)="addToGuestList()"
        >
          <i class="ri-user-add-fill"></i> <ng-container i18n="@@add-person">Person hinzufügen</ng-container>
        </div>
        <div
          class="btn btn-outline-primary"
          (click)="this.mode = 'input'"
        >
          <i class="ri-group-fill"></i> <ng-container i18n="@@import">Importieren</ng-container>
        </div>
        <div
          class="btn btn-outline-primary"
          (click)="exportGuestList()"
        >
          <i class="ri-download-line"></i> <ng-container i18n="@@export">Exportieren</ng-container>
        </div>
      </div>
    </div>
  </div>
  <div
    class="row justify-content-end mt-1"
    *ngIf="this.linkOption === 'recording' && this.hasRecordAValidRoom"
  >
    <div class="col-auto">
      <div
        class="btn btn-outline-primary"
        (click)="copyListFromRoomConfig()"
      >
        <i class="ri-file-copy-fill"></i> <ng-container i18n="@@copy-participants">Teilnehmer von Raum-Liste
          kopieren</ng-container>
      </div>
    </div>
  </div>
  <hr>
  <div
    class="row align-items-center"
    *ngIf="this.shownGuests.length > 0"
  >
    <div class="col-auto">
      <span class="me-2">
        <input
          [ngModel]="selectedIncludesAllShown()"
          (ngModelChange)="changeAllSelected($event)"
          type="checkbox"
        >
      </span>
      <b i18n="@@guests-selected">{{this.selectedGuests.length}}/{{this.list.length}} selektiert</b>
    </div>
    <div class="col-auto">
      <div
        class="btn btn-outline-danger btn-sm"
        (click)="confirmDelete(confirmModal)"
        [ngClass]="{'disabled': this.list.length === 0 || this.selectedGuests.length === 0}"
        i18n="@@delete-selected"
      >Ausgewählte löschen</div>
    </div>
    <div class="col"></div>
  </div>
  <div
    class="row align-items-center my-2"
    *ngFor="let guest of shownGuests"
  >
    <div class="col-auto">
      <input
        type="checkbox"
        [ngModel]="this.selectedGuests.includes(guest.id)"
        (change)="changeSelection(guest.id)"
      >
    </div>
    <div class="col-auto"><i
        class="ri-user-fill ri-lg"
        style="cursor: default;"
      ></i></div>
    <div class="col-3"><input
        class="form-control"
        [(ngModel)]="guest.name"
        (blur)="this.updateSingleGuest(guest)"
      ></div>
    <div class="col-3">
      <div class="input-group">
        <input
          #input
          class="form-control"
          type="password"
          [(ngModel)]="guest.password"
          (blur)="this.updateSingleGuest(guest)"
        >
        <div
          class="btn btn-outline-primary"
          (click)="input.type = input.type === 'password' ? 'text' : 'password'"
        >
          <i [ngClass]="{'ri-eye-line': input.type !== 'password', 'ri-eye-close-line': input.type === 'password'}"></i>
        </div>
      </div>
    </div>
    <div class="col cut-text"><input
        [ngModel]="window.location.origin + guest.link"
        [disabled]="true"
        class="form-control"
      >
    </div>
    <div
      class="col-auto"
      *ngIf="this.record"
    >
      <span *ngIf="guest.hasWatchedRecording === undefined">
        <i
          class="ri-check-line ri-2x text-secondary"
          placement="top"
          i18n-tooltip="@@recording-link-not-opened"
          tooltip="Aufzeichnungslink nicht aufgerufen"
        ></i>
      </span>
      <span *ngIf="guest.hasWatchedRecording === false">
        <i
          class="ri-check-line ri-2x text-warning"
          placement="top"
          i18n-tooltip="@@recording-link-opened"
          tooltip="Aufzeichnungslink aufgerufen"
        ></i>
      </span>
      <span *ngIf="guest.hasWatchedRecording === true">
        <i
          class="ri-check-line ri-2x text-success"
          placement="top"
          i18n-tooltip="@@recording-watched"
          tooltip="Aufzeichnung vollständig gesichtet"
        ></i>
      </span>
    </div>
    <div class="col-auto text-danger">
      <i
        class="ri-delete-bin-line ri-lg"
        (click)="this.selectedGuests = [guest.id]; confirmDelete(confirmModal)"
      ></i>
    </div>
  </div>
</ng-container>

<div *ngIf="this.mode === 'input'">
  <div class="row">
    <div class="col-auto">
      <div
        class="btn btn-light"
        (click)="this.mode = 'edit'"
      >
        <i class="ri-arrow-left-line"></i>Zurück
      </div>
    </div>
    <div class="col"></div>
    <div class="col-auto">
      <a
        class="btn btn-outline-primary"
        #demoDownload
        href="assets/Demo-Guestlist-Import.xlsx"
        download="Demo-Guestlist-Import.xlsx"
      ><i class="ri-download-line"></i>Demo-Datei</a>
    </div>
  </div>
  <div class="text-center">
    <input
      #importInput
      type="file"
      class="visually-hidden"
      id="excelInput"
      name="excelInput"
      accept=".xls, .xlsx"
      (change)="onExcelInput($event)"
    >
    <div
      *ngIf="this.importInput.value === ''"
      class="btn btn-primary"
      (click)="importInput.click()"
      i18n="@@choose-file"
    >Datei auswählen</div>
    <div
      *ngIf="this.importInput.value !== ''"
      class="btn btn-primary"
      (click)="importGuestList()"
      i18n="@@import-guests"
    >Gäste importieren</div>
  </div>
  <hr>
  <app-card>
    <!-- TODO: TRANSLATED LABELS-->
    <lib-rag-datasupply-table
      *ngIf="this.importInput.value !== ''"
      [translatedLabels]="this.translatedLabels"
      [service]="frontendService"
      [columns]="[
      {fieldName: 'name', label: 'Name'},
      {fieldName: 'password', label: 'Passwort'}
    ]"
      i18n-noDataText="@@no-guests"
      noDataText="Keine Gäste vorhanden."
      [overrideTableClasses]="''"
    ></lib-rag-datasupply-table>
  </app-card>
</div>


<ng-template #confirmModal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close close pull-right"
      aria-label="Close"
      (click)="modalRef?.hide()"
    >
      <span
        aria-hidden="true"
        class="visually-hidden"
      >&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ng-container i18n="@@confirm-removal-guest-list">Sind Sie sicher, dass die {{selectedGuests.length}} Gäste von der
      Liste entfernen wollen?</ng-container>
    <div class="text-center m-3">
      <div class="btn-group">
        <div
          class="btn btn-outline-secondary btn-sm"
          (click)="modalRef?.hide()"
          i18n="@@no"
        >Nein</div>
        <div
          class="btn btn-outline-danger btn-sm"
          (click)="deleteSelected(); modalRef?.hide()"
          i18n="@@yes"
        >Ja</div>
      </div>
    </div>
  </div>
</ng-template>